import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import isToday from 'date-fns/isToday';
import isYesterday from 'date-fns/isYesterday';
import { TimeGroup } from '@atlassian/notification-common/types';
export default function timeGroupNotifications(renderableNotifications) {
  var notificationMap = new Map([[TimeGroup.TODAY, []], [TimeGroup.YESTERDAY, []], [TimeGroup.OLDER, []]]);
  renderableNotifications.reduce(timeGroupNotification, notificationMap);
  return convertTimeGroupMapToTimeGroupArray(notificationMap);
}
export function convertToTimeGroups(groups) {
  var timeGroupMap = new Map([[TimeGroup.TODAY, []], [TimeGroup.YESTERDAY, []], [TimeGroup.OLDER, []]]);
  groups.forEach(function (group) {
    var headNotification = group.notifications[0];
    if (!headNotification) {
      return;
    }
    var timeGroup = getTimeGroupForTimestamp(headNotification.timestamp);
    var data = timeGroupMap.get(timeGroup);
    if (data) {
      data.push(group);
    }
  });
  return convertTimeGroupMapToTimeGroupArray(timeGroupMap).filter(function (timeGroup) {
    return timeGroup.data.length > 0;
  });
}
function timeGroupNotification(notificationMap, currentNotification) {
  var timeGroup = getTimeGroupForTimestamp(currentNotification.timestamp);
  var currentNotifications = notificationMap.get(timeGroup);
  if (currentNotifications) {
    currentNotifications.push(currentNotification);
  }
  return notificationMap;
}
function convertTimeGroupMapToTimeGroupArray(map) {
  return Array.from(map, function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      timeGroup = _ref2[0],
      data = _ref2[1];
    return {
      timeGroup: timeGroup,
      data: data
    };
  });
}
function getTimeGroupForTimestamp(timestamp) {
  var date = new Date(timestamp);
  if (isToday(date)) {
    return TimeGroup.TODAY;
  } else if (isYesterday(date)) {
    return TimeGroup.YESTERDAY;
  } else {
    return TimeGroup.OLDER;
  }
}